{
  "it": {
    "task_assignment": {
      "actions": {
        "confirm": "Contrassegna come completata",
        "create": "Attività",
        "reopen": "Riapri",
        "update": "Modifica attività"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Dipendente",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Responsabile",
        "assignees": "Responsabili",
        "created_at": "Creato",
        "due_date": "Scadenza",
        "project": "Progetto",
        "published": "Pubblicata",
        "status": "Stato",
        "task": "Attività",
        "unit": "Unità"
      },
      "labels": {
        "add_assignee": "Aggiungi un responsabile…",
        "add_customers": "Aggiungi clienti",
        "already_assigned": "Questa attività è già stata aggiunta a questa unità.",
        "completed": "Completata",
        "confirm_message": "È sicuro di voler contrassegnare questa attività come completata?",
        "customers": "Clienti",
        "my_tasks": "Le mie attività",
        "no_assignees": "Ancora nessun responsabile assegnato.",
        "no_assignments": "Ancora nessuna attività.",
        "no_assignments_task": "Ancora nessuna assegnazione per questa attività.",
        "no_assignments_unit": "Ancora nessuna attività per questa unità.",
        "publish_all": "Pubblica tutto",
        "publish_customers": "Pubblica per i clienti di ogni unità",
        "published": "Pubblicata",
        "required": "Questo campo è obbligatorio",
        "select_task": "Selezioni un'attività",
        "upload_hint": "Carichi i documenti richiesti per completare questa attività.",
        "uploaded_documents": "Documenti caricati"
      },
      "statuses": {
        "completed": "Completata",
        "draft": "Bozza",
        "pending": "In attesa"
      },
      "toasts": {
        "completed": "Attività completata",
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "uncompleted": "Attività riaperta",
        "update": "Attività aggiornata"
      }
    }
  }
}
